import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';
import { MaybeRefOrGetter, toValue } from '@vueuse/core';
import { computed } from 'vue';

export interface PromotionItem {
	id: string;
	type: 'sqtv' | 'qtv' | 'ft';
	shortName: string;
}

export function useGridSwiperExp(enabled: MaybeRefOrGetter<boolean> = true) {
	const { activeVariantWithControlGroup: variant, experimentInfo } = useExperiment('EXP_GRID_SWIPER');

	const promotionItems = computed((): PromotionItem[] => {
		return [
			{ id: 'ft-1', type: 'ft', shortName: 'atp' },
			{ id: 'sqtv-2', type: 'sqtv', shortName: 'amp' },
			{ id: 'qtv-1', type: 'qtv', shortName: 'hlu' },
		];
	});

	function setGridSwiperTags(url: ClickoutUrl, placement: 'sqtv' | 'ft' | 'qtv', shortName: string) {
		if (!variant.value || !toValue(enabled)) return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		const tag = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: 'US',
			placement,
			providerShortName: shortName,
		});

		url.set('uct_ctag', tag);

		return url;
	}

	return {
		promotionItems,
		setGridSwiperTags,
	};
}
